/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Info16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M8.5 6.5H6.25a.75.75 0 000 1.5H7v4.5h-.75a.75.75 0 100 1.5H10a.75.75 0 100-1.5h-.75V7.41s.006-.217-.02-.327A.753.753 0 008.5 6.5zM7.75 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default Info16;
